module.exports = __webpack_public_path__ + "img/banking-providers.994ec4d.webp";